import { render, staticRenderFns } from "./Commandes.vue?vue&type=template&id=843ca60c&scoped=true&"
import script from "./Commandes.js?vue&type=script&lang=js&"
export * from "./Commandes.js?vue&type=script&lang=js&"
import style0 from "./Commandes.scoped.scss?vue&type=style&index=0&id=843ca60c&lang=scss&scoped=true&"
import style1 from "./Commandes.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843ca60c",
  null
  
)

export default component.exports